
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/team/[name]/[id]/highlights",
      function () {
        return require("private-next-pages/team/[name]/[id]/highlights/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/team/[name]/[id]/highlights"])
      });
    }
  